import cookies from 'browser-cookies';
export { CookieOptions } from 'browser-cookies';

const getDomain = () => {
  try {
    const hostname = window.location.hostname;
    const hostnameParts = hostname.split('.');
    const pathSplit = /\.co\.|\.com\.|\.org\.|\.edu\.|\.net\.|\.asn\./.test(hostname) ? 3 : 2;
    const domain = hostnameParts.splice(hostnameParts.length - pathSplit, pathSplit).join('.');
    return domain;
  } catch (e) {
    // https://github.com/voltace/browser-cookies#cookies-defaults
    return '';
  }
};

function eraseCookie(name, options) {
  var _options$domain;
  return cookies.erase(name, {
    ...options,
    domain: (_options$domain = options === null || options === void 0 ? void 0 : options.domain) != null ? _options$domain : getDomain()
  });
}

function getAllCookies() {
  return cookies.all();
}

function getCookie(name) {
  return cookies.get(name);
}

function setCookie(name, value, options) {
  var _options$domain;
  return cookies.set(name, value, {
    ...options,
    domain: (_options$domain = options === null || options === void 0 ? void 0 : options.domain) != null ? _options$domain : getDomain()
  });
}

export { eraseCookie, getAllCookies, getCookie, setCookie };
